import { NavigateFunction, Outlet, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { Button, Grid, GridColumn, GridRow, Header, Icon, Menu, Popup } from 'semantic-ui-react'
import { useHybridAuth } from '../auth/HybridAuthContext';
import Footer from './Footer'
import '../components/NavMenu.css'
import DriverSync from '../pages/DriverSync';
import { preferencesService } from '../services';
import { RequestPayload } from '../services/ApiClient/types';

type Props = {}



const NavMenu = (props: Props) => {
    const { logout, user: authUser } = useHybridAuth();
    const [DriverSync, setDriverSync] = useState(false)
    // const menuArr: string[] = ['Analytics', 'Routed', 'FetchGoatNow', 'Monitoring', 'Logs', 'Reports', 'Support', 'Tracking', 'RouteStopTemplates', 'Search', 'DriverSync']
    const menuArr: string[] = ['Analytics', 'Routed', 'FetchGoatNow', 'Logs', 'Reports', 'Support', 'Tracking', 'RouteStopTemplates', 'Search', 'DriverSync'] // Monitoring removed temporarily
    var index: number = menuArr.indexOf('RouteStopTemplates');
    if (index !== -1) {
        localStorage.courierId === "null" && menuArr.splice(index, 1)
        var index2 = menuArr.indexOf('DriverSync');
        // if (index2 !== -1) {
        //     DriverSync && menuArr.splice(index2, 1)
        // }
        if (!DriverSync) {
            menuArr.splice(index2, 1)
        }
    }
    const [activeItem, setActiveItem] = useState<string>(localStorage.getItem("route"))
    const navigate: NavigateFunction = useNavigate();
    const userUserName = authUser?.userName;

    const isFGAdmin = authUser?.admin === true && typeof authUser?.email === 'string' && authUser.email.toLowerCase().endsWith('@fetchgoat.com');
    if (isFGAdmin && !menuArr.includes('FGAdmin')) {
        menuArr.push('FGAdmin');
    }


    const handleItemClick = (e: any, { name }: any) => {
        let selectedMenuItem
        name === 'Settings' ? selectedMenuItem = 'Preferences' : selectedMenuItem = name;
        if (selectedMenuItem.includes('Dashboard')) {
            var extension: string = "/Routed";
            selectedMenuItem = selectedMenuItem.concat(extension.toString())
        }

        localStorage.setItem("route", selectedMenuItem);

        navigate(`/${selectedMenuItem}`)
        selectedMenuItem.includes("Dashboard") ? setActiveItem("Dashboard") : setActiveItem(selectedMenuItem);
    }
    const getUserPref = () => {
        let payload: RequestPayload<null> = { payload: null }
        preferencesService.GetUserPreferences(payload)
            .then(res => {
                const featuresArr = res.result.applicationFeatures;
                // featuresArr.push({ name: 'DriverSync' }) //test for DriverSync
                const hasDriverSync = featuresArr.length > 0 && featuresArr.some(featureObj => Object.values(featureObj).some(featureName => featureName.includes("DriverSync")));
                setDriverSync(hasDriverSync);
            })
    }

    useEffect(() => {
        const loggedInUser = localStorage.getItem("authenticated");
        if (JSON.parse(loggedInUser) === false) {
            navigate('/')
        }
        setActiveItem(localStorage.route)
        getUserPref()

    }, [navigate]);


    const handleLogout = () => {
        localStorage.setItem("authenticated", 'false');
        localStorage.removeItem("token");
        localStorage.removeItem("courierId");
        logout();
        navigate("/");
    }
    return (
        <>
            <div className='background'>
                <div className='header-container'>
                    <Menu pointing inverted className="navMenu">
                        <Menu.Item >
                            <img src="/images/FetchGoat_white - 460x60 - long.png" alt="logo" className="navMenuLogo" />
                        </Menu.Item>
                        {menuArr.map((title: string, id: number) => {
                            return (
                                <Menu.Item
                                    key={id}
                                    name={title}
                                    active={activeItem === title.replace(/\s/g, '')}
                                    onClick={handleItemClick}
                                    className="navMenuItem"
                                />
                            )
                        })}

                        <Menu.Menu position='right'>
                            <Menu.Item
                            // name={`${userUserName} ${userEmail}`}
                            >
                                <Popup trigger={
                                    <p><Icon name='user' />{userUserName === undefined || null ? 'User' : userUserName?.charAt(0).toUpperCase() + userUserName?.slice(1)}</p>
                                }
                                    flowing hoverable inverted position='bottom center'>
                                    <Grid centered divided>
                                        {/* Disables until alerts are added */}
                                        {/* <GridRow>
                                            <GridColumn textAlign='center'>
                                                <Menu.Item
                                                    key={5}
                                                    name={'Monitoring'}
                                                    active={activeItem === 'Monitoring'}
                                                    onClick={handleItemClick}
                                                    style={{ color: 'white', textDecoration: 'none', cursor: 'pointer' }}
                                                />
                                            </GridColumn>
                                        </GridRow> */}
                                        <GridRow>
                                            <GridColumn textAlign='center'>
                                                <Menu.Item
                                                    key={5}
                                                    name={'Settings'}
                                                    active={activeItem === 'Preferences'}
                                                    onClick={handleItemClick}
                                                    style={{ color: 'white', textDecoration: 'none', cursor: 'pointer' }}
                                                />
                                            </GridColumn>
                                        </GridRow>
                                        <GridRow>
                                            <GridColumn textAlign='center'>
                                                <Menu.Item
                                                    name='Log Out'
                                                    active={activeItem === 'Log Out'}
                                                    // onClick={() => handleLogout('/')}
                                                    onClick={() => handleLogout()}
                                                    style={{ color: 'white', textDecoration: 'none', cursor: 'pointer' }}
                                                />
                                            </GridColumn>
                                        </GridRow>
                                    </Grid>
                                </Popup>
                                {/* {userUserName.charAt(0).toUpperCase() + userUserName.slice(1)} */}

                            </Menu.Item>
                            {/* <Menu.Item
                                name='Log Out'
                                active={activeItem === 'Log Out'}
                                // onClick={() => handleLogout('/')}
                                onClick={() => handleLogout()}
                            /> */}
                        </Menu.Menu>
                    </Menu>
                </div>

                <Outlet />
                <Footer />
            </div>
        </>
    )
}

export default NavMenu